/**
 * The staged-object record.
 *
 * Mirrors the dorm `decorEntry` but differs in three ways that matter:
 *
 *  - OWNERSHIP is stamped positively (`addedBy` + `styleProvenance`). Every
 *    predicate that decides a prop's fate reads that, not the type string.
 *  - `story` is OMITTED, not set to 0. 67 of 323 corpus rooms sit above
 *    storey 0, and `matchesStory` treats a missing story as visible on every
 *    storey while a hardcoded 0 would file a second-floor bathroom's props on
 *    the ground floor. The repo has already paid for that once, in
 *    wallStructureUtils' ghost pass.
 *  - `parents` names the host a prop rests on. That is the linkage every
 *    countertop in this codebase already carries, and it is what makes
 *    `moveGroup` drag the props when someone moves the vanity and `moveUnit`
 *    carry them through a collision nudge — a reconciler we get for free
 *    rather than one we have to write.
 */

const { STAGING_TOOL } = require('../ownership');

function stagingEntry({
  id,
  type,
  center,
  dimensions,
  rotation = { x: 0, y: 0, z: 0 },
  attributes = {},
  parentWallIds = [],
  host = null,
  styleId = null,
  generatedAt = null,
}) {
  const entry = {
    id,
    type,
    category: { [type]: {} },
    center,
    rotation,
    dimensions,
    attributes,
    addedBy: STAGING_TOOL,
    styleProvenance: {
      tool: STAGING_TOOL,
      styleId: styleId || null,
      generatedAt: generatedAt || null,
    },
    parentWallIds,
  };
  if (host && host.id) {
    entry.parents = [{ id: host.id, type: host.type || null }];
  }
  return entry;
}

module.exports = { stagingEntry };
